import { observer } from "mobx-react-lite";
import { BreadCrumb } from "primereact/breadcrumb";
import { Fieldset } from "primereact/fieldset";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FailedLoading from "../../../../app/common/FailedLoading/FailedLoading";
import SectionHeading from "../../../../app/common/SectionHeading/SectionHeading";
import Loading from "../../../../app/layout/Loading/Loading";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { appColors } from "../../../../colors";
import ProjectSettingsGeneralInformation from "./LocalComponents/ProjectSettingsGeneralInformation";
import ProjectMembers from "./LocalComponents/ProjectMembers";
import ProjectSettingsStageOverride from "./LocalComponents/ProjectSettingsStageOverride";
import CompoundsStats from "./LocalComponents/CompoundsStats";

const ProjectSettings = ({ id, project }) => {
  /* MobX Store */
  const rootStore = useContext(RootStoreContext);
  // const { user } = rootStore.userStore;
  const { loadingProject, fetchProject, selectedProject } =
    rootStore.projectStore;

  const navigate = useNavigate();

  useEffect(() => {
    if (selectedProject === null || selectedProject.id !== id) {
      fetchProject(id);
    }
  }, [id, selectedProject, fetchProject]);

  /* Loading Overlay */
  if (loadingProject) {
    return <Loading />;
  }

  if (
    !loadingProject &&
    selectedProject !== null &&
    selectedProject.id === id
  ) {
    const breadCrumbItems = [
      {
        label: "Project Management",
        command: () => {
          navigate("/pm/");
        },
      },
      {
        label: "Projects",
        command: () => {
          navigate("/pm/project");
        },
      },
      { label: selectedProject.projectName },
    ];

    return (
      <React.Fragment>
        <div className="flex flex-column w-full">
          <div className="flex w-full pb-2">
            <BreadCrumb model={breadCrumbItems} />
          </div>

          <div className="flex w-full">
            <SectionHeading
              icon="icon icon-common icon-briefcase"
              heading={project.projectName + " | " + project?.currentStage}
              targetName={project.targetName}
              displayHorizon={true}
              color={appColors.sectionHeadingBg.project}
            />
          </div>

          <div className="flex w-full gap-3">
            {/* ── Left Column ── */}
            <div className="flex flex-column gap-3" style={{ flex: 1, minWidth: 0 }}>
              <div className="flex">
                <Fieldset className="w-full" legend="📋 Project Information">
                  <ProjectSettingsGeneralInformation
                    project={selectedProject}
                  />
                </Fieldset>
              </div>
              <div className="flex">
                <Fieldset className="w-full" legend="📊 Compounds">
                  <CompoundsStats projectId={id} />
                </Fieldset>
              </div>
            </div>

            {/* ── Right Column ── */}
            <div className="flex flex-column gap-3" style={{ flex: 1, minWidth: 0 }}>
              <div className="flex">
                <Fieldset className="w-full" legend="🔄 Project Stage Override">
                  <ProjectSettingsStageOverride project={selectedProject} />
                </Fieldset>
              </div>
              <div className="flex">
                <Fieldset className="w-full" legend="👥 Project Members">
                  <ProjectMembers projectId={id} />
                </Fieldset>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return <FailedLoading />;
};

export default observer(ProjectSettings);
